import $ from 'jquery';

const collapseTextMobile = () => {
    const el = ".collapse-text";

    if ($(el).length === 0) return;

    const svgIcon = `<svg class="collapse-text-icon" width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; vertical-align: middle; margin-left: 6px; transition: transform 0.3s ease;">
  <path d="M13.95 0.75L8.51667 6.18333C7.875 6.825 6.825 6.825 6.18333 6.18333L0.75 0.75" stroke="#113545" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

    const textContentMore = 'Lees meer';
    const textContentLess = 'Minder lezen';

    const mobileBtnHtml = `<div class="collapse-text-btn" style="cursor: pointer; display: inline-flex; align-items: center; font-weight: 600; color: #113545;">
        <span class="collapse-text-label">${textContentMore}</span>
        ${svgIcon}
    </div>`;

    const isMobile = () => window.innerWidth <= 767;

    const exec = () => {
        $(el).each(function () {
            const $this = $(this);

            let $content = $this.find('.collapse-text-inner');
            if ($content.length === 0) {
                $this.contents().wrapAll('<div class="collapse-text-inner"></div>');
                $content = $this.find('.collapse-text-inner');
            }

            const $hero = $this.closest('.hero-section').length
                ? $this.closest('.hero-section')
                : $('.hero-section');

            if (isMobile()) {
                if (!$this.hasClass('mobile-collapse-initialized')) {
                    $this.addClass('mobile-collapse-initialized');

                    $content.css({
                        'max-height': '0em',
                        'overflow': 'hidden',
                        'transition': 'max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                        'position': 'relative'
                    });

                    if ($hero.length) {
                        $hero.addClass('is-collapsed is-text-collapsed').removeClass('is-expanded is-text-expanded');
                    }

                    $this.find('.collapse-text-btn').remove();

                    const $btn = $(mobileBtnHtml);
                    $content.after($btn);

                    $btn.off('click.collapseText').on('click.collapseText', function (e) {
                        e.preventDefault();
                        const isExpanded = $this.hasClass('is-expanded');

                        if (isExpanded) {
                            $this.removeClass('is-expanded');
                            $content.css('max-height', '0em');
                            $btn.css('margin-top', '0px')
                            $btn.find('.collapse-text-label').text(textContentMore);
                            $btn.find('.collapse-text-icon').css('transform', 'rotate(0deg)');
                            if ($hero.length) {
                                $hero.addClass('is-collapsed is-text-collapsed').removeClass('is-expanded is-text-expanded');
                            }
                        } else {
                            $this.addClass('is-expanded');
                            const fullHeight = $content[0].scrollHeight;
                            $content.css('max-height', fullHeight + 'px');
                            $btn.css('margin-top', '12px');
                            $btn.find('.collapse-text-label').text(textContentLess);
                            $btn.find('.collapse-text-icon').css('transform', 'rotate(180deg)');
                            if ($hero.length) {
                                $hero.addClass('is-expanded is-text-expanded').removeClass('is-collapsed is-text-collapsed');
                            }
                        }
                    });
                }
            } else {
                if ($this.hasClass('mobile-collapse-initialized')) {
                    $this.removeClass('mobile-collapse-initialized is-expanded');
                    $content.css({
                        'max-height': '',
                        'overflow': '',
                        'transition': '',
                        'position': ''
                    });
                    $this.find('.collapse-text-btn').remove();
                    if ($hero.length) {
                        $hero.removeClass('is-collapsed is-text-collapsed is-expanded is-text-expanded');
                    }
                }
            }
        });
    };

    exec();

    let resizeTimer;
    $(window).on('resize orientationchange', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(exec, 100);
    });
};

try {
    collapseTextMobile();
} catch (error) {
    console.warn(error.message);
}